export enum UserDetailsPlatformAccessOperation {
    create = "ea85eea9-2ee5-4f69-9036-5c7dec94a2ff",
    read = "81d7efa1-f156-4aed-b134-df0ed25b8671",
    update = "cc9f8400-8e19-44de-92a5-81d93bc35363",
    delete = "1f73228f-45be-4181-b831-2142c7e3775e",
}
